// Типы каналов и их правила (CHN-UC-5). Используются проверкой готовности
// (POST-UC-7) и пакетом публикации (PUB-UC-2).
export enum ChannelType {
  Telegram = 'telegram',
  Instagram = 'instagram',
  Vk = 'vk',
  Max = 'max',
  Other = 'other',
}

export const CHANNEL_TYPES: readonly ChannelType[] = Object.values(ChannelType);

export function isChannelType(value: unknown): value is ChannelType {
  return CHANNEL_TYPES.includes(value as ChannelType);
}

export enum PublishMode {
  Manual = 'manual',
}

export interface ChannelRules {
  /** Лимит подписи к посту с медиа, символов; null — без ограничения. */
  captionLimit: number | null;
  hashtagLimit: number | null;
  mediaLimit: number | null;
  /** Принимаемые расширения файлов; null — любые. */
  acceptedExtensions: readonly string[] | null;
}

export const CHANNEL_RULES: Readonly<Record<ChannelType, ChannelRules>> = {
  [ChannelType.Telegram]: {
    captionLimit: 1024,
    hashtagLimit: null,
    mediaLimit: 10,
    acceptedExtensions: ['jpg', 'jpeg', 'png', 'webp', 'mp4', 'mov'],
  },
  [ChannelType.Instagram]: {
    captionLimit: 2200,
    hashtagLimit: 5,
    mediaLimit: 20,
    acceptedExtensions: ['jpg', 'jpeg', 'png', 'mp4', 'mov'],
  },
  // Предварительные значения, уточнить перед автоматизацией (CHN, «Вне рамок»).
  [ChannelType.Vk]: {
    captionLimit: 16384,
    hashtagLimit: null,
    mediaLimit: 10,
    acceptedExtensions: ['jpg', 'jpeg', 'png', 'gif', 'mp4', 'mov'],
  },
  [ChannelType.Max]: {
    captionLimit: 4000,
    hashtagLimit: null,
    mediaLimit: 10,
    acceptedExtensions: ['jpg', 'jpeg', 'png', 'mp4'],
  },
  [ChannelType.Other]: {
    captionLimit: null,
    hashtagLimit: null,
    mediaLimit: null,
    acceptedExtensions: null,
  },
};
